import { render, staticRenderFns } from "./FixedAssetRecordForm.vue?vue&type=template&id=729d3564&scoped=true"
import script from "./FixedAssetRecordForm.vue?vue&type=script&lang=js"
export * from "./FixedAssetRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729d3564",
  null
  
)

export default component.exports